<template>
  <div>
    <template v-if="messageOnly">
      <v-dialog :model-value="showDialog" persistent max-width="400">
        <v-card>
          <v-toolbar color="warning" dense>
            <v-spacer></v-spacer>
            <v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-card-text> {{ message }} </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click.native.stop="dummy()">{{ $t('OK') }}</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </template>

    <template v-if="!messageOnly">
      <v-dialog :model-value="showDialog" persistent max-width="400">
        <v-card>
          <v-toolbar color="warning" dense>
            <v-spacer></v-spacer>
            <v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-card-text> {{ message }} </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text class="card-button" @click="addUser()">{{ $t('Add') }}</v-btn>
                  <v-btn color="primary" text class="card-button" @click="removeUser()">{{ $t('Cancel') }}</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import { removeUserFromArray } from '@/common/userFunctions'
export default {
  name: 'UserGroupMessageDialog',
  data: () => ({
    // showDialog: false
  }),
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    message: {
      type: String
    },
    messageOnly: {
      type: Boolean,
      default: true
    },
    user: {
      type: Object
    },
    childGroup: {
      type: Array
    },
    parentGroup: {
      type: Array
    },
    keepBothOnYes: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    addUser: function() {
      if (!this.keepBothOnYes) {
        if (this.user && this.childGroup) {
          let results = removeUserFromArray(this.user, this.childGroup[1])
          this.$emit('results', { groupName: this.childGroup[0], users: results })
          return
        }
      } else {
        this.$emit('results', { groupName: this.childGroup[0], users: this.childGroup[1] })
        return
      }
    },
    removeUser: function() {
      if (this.user && this.parentGroup) {
        if (this.keepBothOnYes) {
          if (this.parentGroup[0] === 'owner') {
            // the user has decided to not set the owner, so put back the owner that was there
            this.$emit('results', { groupName: this.parentGroup[0], users: [this.parentGroup[1]] })
            return
          }

          let results = removeUserFromArray(this.user, [this.parentGroup[1]])

          this.$emit('results', { groupName: this.parentGroup[0], users: results })
          return
        }
        this.$emit('results', { groupName: this.parentGroup[0], users: this.user })
        return
      }
    },
    dummy: function() {
      this.$emit('results', [], [])
    }
  }
}
</script>

<style scoped></style>
